function CameraTween() {
	this.origin = {};
	this.destination = {};
	this.current = {};
	this.origin.x = 0;
	this.origin.y = 0;
	this.origin.zoom = 0;
	this.running = false;
	this.onFinish = null;
	this.speed = 20;
};

CameraTween.prototype = {	

	setSpeed: function(s) {
		this.speed = s;
	},

	reset: function() {
		this.origin = {};
		this.destination = {};
		this.current = {};
		this.origin.x = 0;
		this.origin.y = 0;
		this.origin.zoom = 0;
		this.running = false;
		this.onFinish = null;
		this.speed = 20;
	},

	zooming: function(from, to) {
		this.sdt = Date.now();
		this.origin.zoom = from;
		this.current.zoom = from;
		this.destination.zoom = to;
		this.distance = this.speed;

		this.running = true;
	},

	addZoom: function(dest, speed) {
		this.destination.zoom += dest;
		this.distance += speed;
	},

	startAt: function(rx, ry) {
		this.origin.x = rx;
		if (this.origin.x < 0) this.origin.x = 360 + this.origin.x;
		if (this.origin.x > 360) this.origin.x = this.origin.x % 360;
		this.origin.y = ry;

		this.current.x = rx;
		this.current.y = ry;

		this.sdt = Date.now();
	},

	finishAt: function(rx, ry) {
		var dist1 = Math.abs(rx - this.origin.x);
		var dist2 = Math.abs((360 + rx) - this.origin.x);
		var dist3 = Math.abs(rx - (360 + this.origin.x));

		//console.log("Start: " + this.origin.x);
		//console.log("End: " + rx);

		if (dist1 <= dist2 && dist1 <= dist3) {
			this.destination.x = rx;
			this.distance = dist1 * this.speed;
		} else if (dist3 <= dist2) {
			this.destination.x = rx;
			this.origin.x = this.origin.x + 360;
			this.distance = dist3 * this.speed;
		} else {
			this.destination.x = rx + 360;
			this.distance = dist2 * this.speed;
		}

		if (this.distance < 1000) this.distance = 1000;

		this.destination.y = ry;
		this.running = true;
	},

	stop: function() {
		this.running = false;
	},

	isRunning: function() {
		return this.running;
	},

	easeInOutQuad: function (t, b, c, d) {
		t /= d/2;
		if (t < 1) return c/2*t*t + b;
		t--;
		return -c/2 * (t*(t-2) - 1) + b;
	},

	process: function() {
		if (this.running) {
			var cd = Date.now();
			if (this.current.x != undefined) this.current.x = this.easeInOutQuad(cd - this.sdt, this.origin.x, this.destination.x - this.origin.x, this.distance);
			if (this.current.y != undefined) this.current.y = this.easeInOutQuad(cd - this.sdt, this.origin.y, this.destination.y - this.origin.y, this.distance);

			if (this.current.zoom != undefined) {
				this.current.zoom = this.easeInOutQuad(cd - this.sdt, this.origin.zoom, this.destination.zoom - this.origin.zoom, this.distance);
			}

			if (cd - this.sdt > this.distance) {
				this.running = false;
				if (this.onFinish != null) this.onFinish();
			}
			//this.current.x += (this.destination.x - this.current.x) * 0.1;
			//this.current.y += (this.destination.y - this.current.y) * 0.1;
		}
	}
};